import {
  DEMO_STUDENT_WAYBEE_USER_ID,
  isDemoStudentId
} from "./buildDemoStudentProfile";

/** Eixos dos radares de desempenho por período e desempenho geral (demo). */
const RADAR_DISCIPLINAS_DEMO = [
  "Português",
  "Matemática",
  "Ciências",
  "História",
  "Geografia",
  "Inglês",
  "Arte",
  "Educação Física"
];

function isDemoChartUserId(id) {
  // Aceita RA do aluno demo ou o id legado de gráficos
  return (
    id != null &&
    (isDemoStudentId(id) || String(id) === String(DEMO_STUDENT_WAYBEE_USER_ID))
  );
}

/** GET .../statistics-stages */
export function buildDemoChartStages(waybeeUserId) {
  if (!isDemoChartUserId(waybeeUserId)) {
    return [];
  }
  return [
    { id: "ET1", name: "1º bimestre" },
    { id: "ET2", name: "2º bimestre" },
    { id: "ET3", name: "3º bimestre" },
    { id: "ET4", name: "4º bimestre" }
  ];
}

/** GET .../period-performance — Chart.js Radar (um dataset por bimestre) */
export function buildDemoPeriodPerformance(waybeeUserId) {
  if (!isDemoChartUserId(waybeeUserId)) {
    return null;
  }

  const labels = [...RADAR_DISCIPLINAS_DEMO];

  const bimestres = [
    {
      label: "1º bimestre",
      data: [8.2, 7.5, 8.5, 8, 7.8, 8.1, 9, 8.3],
      borderColor: "#00b2b9",
      fillColor: "rgba(0, 178, 185, 0.18)"
    },
    {
      label: "2º bimestre",
      data: [7.5, 8, 8, 7.5, 8, 7.7, 8.5, 7.9],
      borderColor: "#0288d1",
      fillColor: "rgba(2, 136, 209, 0.16)"
    },
    {
      label: "3º bimestre",
      data: [8.5, 7, 9, 8.5, 8.2, 8.4, 8.8, 8.2],
      borderColor: "#7b1fa2",
      fillColor: "rgba(123, 31, 162, 0.14)"
    },
    {
      label: "4º bimestre",
      data: [9, 8.5, 8.5, 9, 8.6, 8.8, 9, 8.1],
      borderColor: "#e65100",
      fillColor: "rgba(230, 81, 0, 0.12)"
    }
  ];

  return {
    labels,
    datasets: bimestres.map(b => ({
      label: b.label,
      data: b.data,
      backgroundColor: b.fillColor,
      borderColor: b.borderColor,
      borderWidth: 2,
      pointBackgroundColor: b.borderColor,
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: b.borderColor
    }))
  };
}

/**
 * GET .../overall-performance — Chart.js Radar.
 * Comparativo: aluno × média da turma × média da série (eixo por disciplina).
 */
export function buildDemoOverallPerformance(waybeeUserId) {
  if (!isDemoChartUserId(waybeeUserId)) {
    return null;
  }

  const labels = [...RADAR_DISCIPLINAS_DEMO];

  const series = [
    {
      label: "Nota do aluno",
      data: [8.2, 7.8, 9, 8.1, 7.6, 8.4, 8, 8.6],
      borderColor: "#00b2b9",
      fillColor: "rgba(0, 178, 185, 0.18)"
    },
    {
      label: "Média da turma",
      data: [7.4, 7.2, 8.1, 7.5, 7.3, 7.5, 7.8, 7.5],
      borderColor: "#0288d1",
      fillColor: "rgba(2, 136, 209, 0.14)"
    },
    {
      label: "Média da série",
      data: [7.1, 7.5, 8.4, 7.9, 7.2, 7.8, 7.9, 8],
      borderColor: "#7b1fa2",
      fillColor: "rgba(123, 31, 162, 0.12)"
    }
  ];

  return {
    labels,
    datasets: series.map(s => ({
      label: s.label,
      data: s.data,
      backgroundColor: s.fillColor,
      borderColor: s.borderColor,
      borderWidth: 2,
      pointBackgroundColor: s.borderColor,
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: s.borderColor
    }))
  };
}

/** GET .../grade-distribuition (typo no ChartService) — HorizontalBar */
export function buildDemoGradeDistribution(waybeeUserId) {
  if (!isDemoChartUserId(waybeeUserId)) {
    return null;
  }

  const disciplines = [
    { id: "demo-dist-pt", name: "Português" },
    { id: "demo-dist-mat", name: "Matemática" }
  ];

  const bimestreMeta = [
    {
      suffix: "1º bim.",
      borderColor: "#00b2b9",
      backgroundColor: "rgba(0, 178, 185, 0.65)"
    },
    {
      suffix: "2º bim.",
      borderColor: "#0288d1",
      backgroundColor: "rgba(2, 136, 209, 0.6)"
    },
    {
      suffix: "3º bim.",
      borderColor: "#7b1fa2",
      backgroundColor: "rgba(123, 31, 162, 0.55)"
    },
    {
      suffix: "4º bim.",
      borderColor: "#e65100",
      backgroundColor: "rgba(230, 81, 0, 0.5)"
    }
  ];

  const ptByBim = [
    [0, 0, 0, 2, 8],
    [0, 0, 1, 3, 6],
    [0, 1, 1, 2, 6],
    [0, 0, 0, 3, 7]
  ];

  const matByBim = [
    [0, 0, 1, 3, 6],
    [0, 0, 0, 4, 6],
    [0, 1, 2, 2, 5],
    [0, 0, 0, 2, 8]
  ];

  /** Alinha a statistics-stages (ET1…ET4) para filtrar por período no front. */
  const periodIds = ["ET1", "ET2", "ET3", "ET4"];

  /** Nota do aluno demo por bimestre (encaixa no intervalo da distribuição). */
  const ptStudentGrades = [9, 6.5, 8.5, 8.8];
  const matStudentGrades = [7.2, 8.1, 5.5, 9.2];

  const datasets = [];

  bimestreMeta.forEach((meta, i) => {
    const periodId = periodIds[i];
    datasets.push({
      label: `${meta.suffix} · Português`,
      discipline: disciplines[0],
      periodId,
      data: ptByBim[i],
      studentGrade: ptStudentGrades[i],
      borderColor: meta.borderColor,
      backgroundColor: meta.backgroundColor
    });
    datasets.push({
      label: `${meta.suffix} · Matemática`,
      discipline: disciplines[1],
      periodId,
      data: matByBim[i],
      studentGrade: matStudentGrades[i],
      borderColor: meta.borderColor,
      backgroundColor: meta.backgroundColor
    });
  });

  return {
    labels: ["0-2", "2-4", "4-6", "6-8", "8-10"],
    disciplines,
    datasets
  };
}
